import {gql} from 'react-apollo';

const USER_PROFILE = gql`query {
  data: userProfile {
    id
    companyName
    user {
    	firstName
    	lastName
    }
    phone
    country
    position
    site
    country
    address
    industry
    business
  }
}`;

const USER_MESSAGES = gql`
query ListProfileMessages($seenOnly: Boolean = false, $newOnly: Boolean = false) {
  data: userMessages(seenOnly: $seenOnly, newOnly: $newOnly) {
    id
    author {
      username
    }
    mType
    title
    text
    createAt
  }
}`;

const USER_UNREAD_MESSAGES_COUNT = gql`query {
  userUnreadMessagesCount
}`;

const COUNTRIES = gql`query {countries: countries}`;

export {USER_MESSAGES, USER_UNREAD_MESSAGES_COUNT, COUNTRIES, USER_PROFILE};


// WEBPACK FOOTER //
// ./src/components/dashboard/profile/gql/query.js